export default (): IPlayerState => ({
  balance: 0,
  username: '',
  verifyName: '',
  isClassic: false,
});
